import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';

import '../../assets/styles/audio.css';
import MUSIC_ICON from '../../assets/images/music-disc.png';
import DOWNLOAD_ICON from '../../assets/images/download-audio.png';
import { listAudios } from '../../actions/AudioActions';
import { scrollToNavigation } from '../../utils/utils';

const playerRef = createRef();

class AudioList extends Component {
    componentDidMount() {
        this.props.listAudios();
    }

    highlightListItem = (li) => {
        const activeListItem = document.querySelector('.audio-item.active');
        if (activeListItem) {
            activeListItem.classList.remove('active');
        }
        li.classList.add('active');
    }

    playAudio = (event) => {
        const targetName = event.target.getAttribute('data-name');
        if (targetName === 'download-track') {
            return;
        }

        event.preventDefault();
        const li = event.currentTarget;
        this.highlightListItem(li);

        const url = event.currentTarget.getAttribute('url');
        const audioPlayer = playerRef.current.audio.current;
        audioPlayer.setAttribute('src', url);
    }

    render() {
        scrollToNavigation();
        const { audiosList, isLoading } = this.props.listAudiosReducer;
        return (
            <div className="audio-page">
                <h1 id="heading">Audio Fatawa</h1>
                <div className="audio-wrapper">
                    <div className="audio-player-box">
                        <AudioPlayer
                            ref={playerRef}
                            src={audiosList.length > 0 ? audiosList[0].file : ''}
                            defaultCurrentTime={<span>00:00</span>}
                            defaultDuration={<span>00:00</span>}
                            autoPlay={false}
                            autoPlayAfterSrcChange={false}
                            customProgressBarSection={
                                [
                                    RHAP_UI.CURRENT_TIME,
                                    RHAP_UI.PROGRESS_BAR,
                                    RHAP_UI.CURRENT_LEFT_TIME,
                                ]
                            }
                            customAdditionalControls={[]}
                        />
                    </div>
                    {
                        (!audiosList || audiosList.length === 0) && (<div>No audio available</div>)
                    }
                    <ul className="audio-list">
                        {
                            audiosList.map((audio, index) => (
                                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                                <li
                                    className={`audio-item ${index === 0 ? 'active' : ''}`}
                                    key={audio.id}
                                    url={audio.file}
                                    onClick={this.playAudio}
                                >
                                    <div className="track-image">
                                        <img src={MUSIC_ICON} className="img-fluid" alt={audio.title} />
                                    </div>
                                    <div className="track-title">
                                        <span>{audio.title}</span>
                                    </div>
                                    <div className="download-audio">
                                        <a
                                            href={audio.file}
                                            download
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <img
                                                src={DOWNLOAD_ICON}
                                                className="img-fluid"
                                                alt={audio.title}
                                                data-name="download-track"
                                            />
                                        </a>
                                    </div>
                                </li>
                            ))
                        }
                    </ul>
                    {
                        audiosList.length === 0 && isLoading && (
                            <div className="loader">
                                <CircularProgress color="inherit" />
                            </div>
                        )
                    }
                </div>
            </div>
        );
    }
}

AudioList.propTypes = {
    listAudiosReducer: PropTypes.object.isRequired,
    listAudios: PropTypes.func.isRequired,
};

function mapStateToProps({ listAudiosReducer }) {
    return {
        listAudiosReducer,
    };
}

export default connect(mapStateToProps, { listAudios })(AudioList);
